import { render, staticRenderFns } from "./PatientRadiologyDetails.vue?vue&type=template&id=492336e4&scoped=true"
import script from "./PatientRadiologyDetails.vue?vue&type=script&lang=js"
export * from "./PatientRadiologyDetails.vue?vue&type=script&lang=js"
import style0 from "./PatientRadiologyDetails.vue?vue&type=style&index=0&id=492336e4&prod&scoped=true&lang=css"
import style1 from "./PatientRadiologyDetails.vue?vue&type=style&index=1&id=492336e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492336e4",
  null
  
)

export default component.exports